import getTaskFolderName from './getTaskFolderName';
import patchProjectTaskFolderId from './patchProjectTaskFolderId';
import { createFolderIdDescriptor, todoCache } from '../todoCache';
import resolveTodoFolderId from '../todoFolderId/resolveTodoFolderId';
import todoFolderIdMap from '../todoFolderId/todoFolderIdMap';
import updateTodoFolderIdMap from '../todoFolderId/updateTodoFolderIdMap';
import { now } from 'owa-datetime';
import { getProject, getSelectedProjectId } from 'owa-timestream-store';
import type { ProjectId } from 'owa-timestream-types';
import { createTodoFolder, loadFolders } from 'owa-todo-folders';

export default function createTaskFolder(projectId?: ProjectId): Promise<string> {
    const selectedProjectId = projectId ?? getSelectedProjectId();
    const { name, tasksParentFolderId } = getProject(selectedProjectId!);

    if (!tasksParentFolderId && !todoFolderIdMap.get(selectedProjectId)) {
        const todoFolderIdPromise = createTodoFolder({
            Name: getTaskFolderName(name),
            IsOwner: true,
            OrderDateTime: now(),
        }).then(todoFolder => {
            if (!!todoFolder) {
                todoCache.taskFolderAdded(createFolderIdDescriptor(todoFolder.Id));
                patchProjectTaskFolderId(selectedProjectId, todoFolder.Id);
                loadFolders();
                return todoFolder.Id;
            }
            return '';
        });

        updateTodoFolderIdMap(selectedProjectId, todoFolderIdPromise);
        return todoFolderIdPromise;
    }

    return !!tasksParentFolderId
        ? Promise.resolve(tasksParentFolderId)
        : resolveTodoFolderId(selectedProjectId);
}
